import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/outline';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { SORT_ORDER } from '../../../lib/constants';
import { mergeClassNames } from '../../../utils';
const SortLabel = ({ isDisabled, children, position, sortName, sortOrder, selectedSortName, className, onSortChange, }) => {
    const sortStyles = 'w-4 h-4 stroke-gray-400';
    const onSortClick = () => {
        let order;
        if (selectedSortName) {
            order = selectedSortName === sortName && sortOrder === SORT_ORDER.ASC ? SORT_ORDER.DESC : SORT_ORDER.ASC;
        }
        else {
            order = !sortOrder
                ? SORT_ORDER.ASC
                : sortOrder === SORT_ORDER.ASC ? SORT_ORDER.DESC : null;
        }
        onSortChange({
            name: sortName,
            order,
        });
    };
    const isSelectedOrder = (order) => {
        return selectedSortName
            ? selectedSortName === sortName && sortOrder === order
            : sortOrder === order;
    };
    return (_jsxs("button", { type: "button", onClick: onSortClick, disabled: isDisabled, className: mergeClassNames('uppercase flex items-center relative', className), children: [children, _jsxs("span", { className: "ml-1.5 flex flex-col", children: [_jsx(ChevronUpIcon, { className: mergeClassNames(sortStyles, { 'stroke-black': isSelectedOrder(SORT_ORDER.ASC) }) }), _jsx(ChevronDownIcon, { className: mergeClassNames(sortStyles, { 'stroke-black': isSelectedOrder(SORT_ORDER.DESC) }) })] }), position ? (_jsx("span", { className: "absolute left-[92%] flex w-5 h-5 justify-center items-center ml-2 bg-gray-200 text-black rounded-full", children: position })) : null] }));
};
SortLabel.propTypes = {
    isDisabled: PropTypes.bool,
    children: PropTypes.string,
    className: PropTypes.string,
    position: PropTypes.number,
    sortOrder: PropTypes.string,
    sortName: PropTypes.string,
    selectedSortName: PropTypes.string,
    onSortChange: PropTypes.func,
};
export default memo(SortLabel);
